"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18next_1 = __importDefault(require("i18next"));
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var react_i18next_1 = require("react-i18next");
i18next_1["default"]
    .use(i18next_http_backend_1["default"])
    .use(i18next_browser_languagedetector_1["default"])
    .use(react_i18next_1.initReactI18next)
    .init({
    supportedLngs: ["ru", "en"],
    fallbackLng: ["ru", "en"],
    debug: true,
    detection: {
        order: ["queryString", "cookie", "path"],
        caches: ["cookie"]
    },
    interpolation: {
        escapeValue: false
    }
});
exports["default"] = i18next_1["default"];
